type TituloSituacao = {
    codigo:number;
    nome:string;
    descricao:string|null;
    ordem:number;
};

export enum EnumTituloSituacao {
    Pendente = 1,
    Liquidado = 2,
    Cancelado = 3,
    AguardandoConfirmacao
}

export default TituloSituacao;